var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArowRightDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1443_13)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29506 1.1646C8.09486 0.974408 7.77838 0.982523 7.58818 1.18273C7.39799 1.38293 7.40611 1.69941 7.60631 1.8896L12.2473 6.29856H0.999512C0.723369 6.29856 0.499512 6.52242 0.499512 6.79856C0.499512 7.0747 0.723369 7.29856 0.999512 7.29856H12.2477L7.60631 11.7079C7.40611 11.8981 7.39799 12.2146 7.58818 12.4148C7.77838 12.615 8.09486 12.6231 8.29506 12.4329L13.8321 7.17278C13.9353 7.08118 14.0004 6.94747 14.0004 6.79856C14.0004 6.64709 13.9331 6.51136 13.8267 6.41967L8.29506 1.1646Z",
    fill: "#1E212A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1443_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 13.5,
    fill: "white",
    transform: "translate(0.5 0.0488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArowRightDark);
export default __webpack_public_path__ + "static/media/arow-right-dark.ec19183c0c3decc6628901987f6f2174.svg";
export { ForwardRef as ReactComponent };